import { Grid, Select, MenuItem, ListItemText, Checkbox, Box, Chip, FormHelperText } from "@mui/material";
import { UseControllerProps, useController } from "react-hook-form";
import { FormControl, InputLabel, OutlinedInput } from "@mui/material";
import { DropdownItem } from "../models/common/dropdownItem";
import AppInformationText, { AppInformationHtmlText } from "./AppInformationText";
import { Theme, useTheme } from '@mui/material/styles';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: "250px",
            margin: '1px !important'
        },
    },
};

interface Props extends UseControllerProps {
    label: string;
    items: DropdownItem[];
    information_text?: string;
    html_information_text?: React.ReactNode;
}

export default function AppMultiSelectList(props: Props) {
    const { fieldState, field } = useController({ ...props, defaultValue: [] });
    const theme = useTheme();
    const value: string[] = Array.isArray(field.value) ? field.value.map(String) : [];

    function getStyles(name: string, personName: readonly string[], theme: Theme) {
        return {
            fontWeight: personName.includes(name)
                ? theme.typography.fontWeightMedium
                : theme.typography.fontWeightRegular,
        };
    }

    const handleDelete = (id: string) => {
        const newValue = value.filter((v) => v !== id);
        field.onChange(newValue);
    };

    return <Grid container rowSpacing={4}>
        <Grid size={{ xs: 11 }}>
            <FormControl fullWidth error={!!fieldState.error}>
                <InputLabel {...field}>{props.label}</InputLabel>
                <Select {...props} {...field}
                    multiple
                    value={value}
                    onChange={(e) => field.onChange(e.target.value)}
                    input={<OutlinedInput label={props.label} />}
                    style={props.disabled === true ? { backgroundColor: '#FAFAFA', color: '#858282' } : {}}
                    renderValue={(selected: string[]) => (
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                            {selected.map((id) => (
                                <Chip key={id} {...props} {...field}
                                    label={props.items.find((x) => String(x.id) === id)?.value}
                                    onDelete={() => handleDelete(id)}
                                    onMouseDown={(e) => e.stopPropagation()}
                                    sx={{
                                        color: 'black',
                                        "&.Mui-disabled": {
                                            background: "#FAFAFA", color: '#858282'
                                        }
                                    }}
                                />
                            ))}
                        </Box>
                    )}
                    MenuProps={MenuProps}
                >
                    {props.items.map((item: DropdownItem, index: number) => (
                        <MenuItem
                            key={index}
                            value={String(item.id)}
                            style={getStyles(String(item.id), value, theme)}
                        >
                            <Checkbox checked={value.includes(String(item.id))} />
                            <ListItemText primary={item.value} />
                        </MenuItem>
                    ))}
                </Select>
                <FormHelperText>{fieldState.error?.message}</FormHelperText>
            </FormControl>
        </Grid>

        {props.information_text &&
            <Grid size={{ xs: 1 }}>
                <AppInformationText information_text={props.information_text} />
            </Grid>}

        {props.html_information_text &&
            <Grid size={{ xs: 1 }}>
                <AppInformationHtmlText information_text={props.html_information_text} />
            </Grid>}
    </Grid>
}
